module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('textbox'), _vm._v(" "), _c('TheFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b405dc7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 95
// module chunks = 2